module.exports = __webpack_public_path__ + "img/cwg_dukayitiji.70915fff.png";